/**
 * Presentational component for profile picture preview and drag-and-drop upload.
 */

import DragDropUpload from "../../../components/dragDropUpload/dragDropUpload";
import { ProfileAvatar } from "../../ProfileAvatar";

/** Props for {@link ProfilePictureUpload}. */
interface ProfilePictureUploadProps {
  /** Current profile picture URL */
  profilePicture: string;
  /** Current profile first name, used for the initials fallback */
  firstName?: string;
  /** Current profile last name, used for the initials fallback */
  lastName?: string;
  /** Provider id used to build the upload storage path */
  providerId?: string;
  /** Whether a profile or facility update is in progress */
  loading: boolean;
  /** Called with uploaded file URLs after a successful upload */
  onUploaded: (url: string[]) => void;
}

/**
 * Renders the profile picture preview and drag-and-drop upload control.
 */
export function ProfilePictureUpload({
  profilePicture,
  firstName,
  lastName,
  providerId,
  loading,
  onUploaded,
}: ProfilePictureUploadProps) {
  return (
    <div className="profile--container__body--profile-pic-container">
      <div className="profile--container__body--profile-pic-container__heading">
        Profile Picture
      </div>
      <div className="profile--container__body--profile-pic-container__content">
        <div className="profile--container__body--profile-pic-container__content--image">
          <ProfileAvatar
            imageUrl={profilePicture}
            firstName={firstName}
            lastName={lastName}
          />
        </div>

        <div className="profile--container__body--profile-pic-container__content--upload">
          <DragDropUpload
            id="profile_picture"
            subText="Supported file format .jpg, .png not exceeding 5MB "
            multipleFilesAllowed={false}
            maxFileSize={5 * 1024 * 1024}
            downloadedURL={onUploaded}
            allowedFileTypes={[".jpg", ".png"]}
            onSuccessfullyUploaded={loading}
            filePath={`user/providers/${providerId}/profile_picture`}
          />
        </div>
      </div>
    </div>
  );
}
